import React from 'react';
import { Route } from 'react-router-dom';

import { SignupPage } from './pages/SignupPage';

export const App = () => (
  <Route path="/">
    <SignupPage />
  </Route>
);
